/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeliveryDiscountAdminDto } from '../models/DeliveryDiscountAdminDto';
import type { DeliveryDiscountType } from '../models/DeliveryDiscountType';
import type { Pagination1OfDeliveryDiscountBranchListedAdminDto } from '../models/Pagination1OfDeliveryDiscountBranchListedAdminDto';
import type { Pagination1OfDeliveryDiscountListedAdminDto } from '../models/Pagination1OfDeliveryDiscountListedAdminDto';
import type { PostDeliveryDiscountAdminRequest } from '../models/PostDeliveryDiscountAdminRequest';
import type { PutDeliveryDiscountBranchesRequestAdmin } from '../models/PutDeliveryDiscountBranchesRequestAdmin';
import type { PutDeliveryDiscountRequestAdmin } from '../models/PutDeliveryDiscountRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeliveryDiscountsService {
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns DeliveryDiscountAdminDto OK
     * @throws ApiError
     */
    public static postDeliveryDiscountAdmin({
        requestBody,
    }: {
        requestBody?: PostDeliveryDiscountAdminRequest,
    }): CancelablePromise<DeliveryDiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/deliverydiscounts',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDeliveryDiscount`
     * @returns Pagination1OfDeliveryDiscountListedAdminDto OK
     * @throws ApiError
     */
    public static getDeliveryDiscountsAdmin({
        type,
        isActive,
        branchId,
        page,
        limit,
    }: {
        type?: DeliveryDiscountType,
        isActive?: boolean,
        branchId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDeliveryDiscountListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/deliverydiscounts',
            query: {
                'type': type,
                'isActive': isActive,
                'branchId': branchId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBranchDeliveryDiscount`
     * @returns DeliveryDiscountAdminDto OK
     * @throws ApiError
     */
    public static getDeliveryDiscountAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DeliveryDiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/deliverydiscounts/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns DeliveryDiscountAdminDto OK
     * @throws ApiError
     */
    public static putDeliveryDiscountAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDeliveryDiscountRequestAdmin,
    }): CancelablePromise<DeliveryDiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/deliverydiscounts/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns Pagination1OfDeliveryDiscountBranchListedAdminDto OK
     * @throws ApiError
     */
    public static getDeliveryDiscountBranchesAdmin({
        id,
        branchId,
        page,
        limit,
    }: {
        id: string,
        branchId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDeliveryDiscountBranchListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/deliverydiscounts/{id}/branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns any OK
     * @throws ApiError
     */
    public static putDeliveryDiscountBranchesAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDeliveryDiscountBranchesRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/deliverydiscounts/{id}/branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns any OK
     * @throws ApiError
     */
    public static postDeliveryDiscountBranchAdmin({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/deliverydiscounts/{id}/branches/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBranchDeliveryDiscount`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteDeliveryDiscountBranchAdmin({
        id,
        branchId,
    }: {
        id: string,
        branchId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/deliverydiscounts/{id}/branches/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
